// Dependencies
import React, { FunctionComponent, ReactNode } from "react";

// Styles
import { Container } from "./styles";

// Types
type WebpOptionListProps = {
    className: string;
    contentComposition: ReactNode;
};

export const WebpOptionList: FunctionComponent<WebpOptionListProps> = ({ contentComposition }) => {
    return <Container>{contentComposition}</Container>;
};
